// Suno models a user can pick when creating a song. Values match the backend.
export const SUNO_MODEL_OPTIONS = [
  { value: 'V6', label: 'V6 (polished)' },
  { value: 'V6_WILD', label: 'V6 Wild (experimental)' },
];

export const DEFAULT_SUNO_MODEL = 'V6';

const SHORT_LABELS = {
  V6: 'V6',
  V6_WILD: 'V6 Wild',
  V6_MINI: 'V6 Mini',
};

export function formatSunoModel(model) {
  if (!model) return '';
  return SHORT_LABELS[model] || model;
}
